import { configureStore } from '@reduxjs/toolkit';
import counterReducer from 'state/counter/counterSlice';
import globalReducer from 'state/global/globalSlice';
import loggerReducer from 'state/logger/loggerSlice';
import authenticationReducer from 'state/authentication/authenticationSlice';
import botStatusReducer from 'state/botStatus/botStatusSlice';
import dictionaryReducer from 'state/dictionary/dictionarySlice';
import clientConfigReducer from 'state/clientConfig/clientConfigSlice';

export const store : any = configureStore({
    reducer: {
        counter: counterReducer,
        global: globalReducer,
        logger: loggerReducer,
        authentication: authenticationReducer,
        botStatus: botStatusReducer,
        dictionary: dictionaryReducer,
        clientConfig: clientConfigReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;